import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBigPicklistInput, FDHeadlineText, FDLabelText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('questionText', {
    _component: () => FDLabelText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => FDBigPicklistInput,
    _customProps: { multiple: false, helperText: '' },
  }, overrideReadOnly);
